// @flow

import * as React from 'react'
import { colors } from '@toggl/style'

type IconProps = {
  color?: string,
}

export const Instagram = ({ color }: IconProps) => (
  <svg viewBox="0 0 16 16" version="1.1">
    <g
      id="Symbols"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Footer-product" transform="translate(-682.000000, -520.000000)">
        <g id="subbar" transform="translate(0.000000, 501.000000)">
          <g id="Group-30" transform="translate(588.000000, 18.000000)">
            <g id="icon-IG" transform="translate(94.000000, 1.000000)">
              <path
                d="M7.99749206,0.00504761905 C5.82549206,0.00504761905 5.55314286,0.0142539683 4.70012698,0.0531746032 C3.84888889,0.092 3.26752381,0.227206349 2.7588254,0.424920635 C2.23292063,0.629269841 1.78692063,0.902730159 1.34228571,1.34733333 C0.89768254,1.79196825 0.624222222,2.23796825 0.419873016,2.76387302 C0.22215873,3.27257143 0.086952381,3.85393651 0.0481269841,4.7051746 C0.00920634921,5.55819048 0,5.83053968 0,8.00253968 C0,10.1745079 0.00920634921,10.4468571 0.0481269841,11.299873 C0.086952381,12.1511111 0.22215873,12.7324762 0.419873016,13.2411746 C0.624222222,13.7670794 0.89768254,14.2130794 1.34228571,14.6577143 C1.78692063,15.1023175 2.23292063,15.3757778 2.7588254,15.5801587 C3.26752381,15.7778413 3.84888889,15.9130476 4.70012698,15.951873 C5.55314286,15.9907937 5.82549206,16 7.99749206,16 C10.1694603,16 10.4418095,15.9907937 11.2948254,15.951873 C12.1460635,15.9130476 12.7274286,15.7778413 13.236127,15.5801587 C13.7620317,15.3757778 14.2080317,15.1023175 14.6526667,14.6577143 C15.0972698,14.2130794 15.3707302,13.7670794 15.5751111,13.2411746 C15.7727937,12.7324762 15.908,12.1511111 15.9468254,11.299873 C15.985746,10.4468571 15.9949524,10.1745079 15.9949524,8.00253968 C15.9949524,5.83053968 15.985746,5.55819048 15.9468254,4.7051746 C15.908,3.85393651 15.7727937,3.27257143 15.5751111,2.76387302 C15.3707302,2.23796825 15.0972698,1.79196825 14.6526667,1.34733333 C14.2080317,0.902730159 13.7620317,0.629269841 13.236127,0.424920635 C12.7274286,0.227206349 12.1460635,0.092 11.2948254,0.0531746032 C10.4418095,0.0142539683 10.1694603,0.00504761905 7.99749206,0.00504761905 Z"
                id="Fill-1"
                fill={color || colors.beige}
              ></path>
              <path
                d="M7.99749206,10.6683492 C6.5251746,10.6683492 5.33165079,9.4748254 5.33165079,8.00253968 C5.33165079,6.53022222 6.5251746,5.33669841 7.99749206,5.33669841 C9.46977778,5.33669841 10.6633016,6.53022222 10.6633016,8.00253968 C10.6633016,9.4748254 9.46977778,10.6683492 7.99749206,10.6683492 Z M7.99749206,3.89571429 C5.72933333,3.89571429 3.89066667,5.73438095 3.89066667,8.00253968 C3.89066667,10.2706667 5.72933333,12.1093333 7.99749206,12.1093333 C10.265619,12.1093333 12.1042857,10.2706667 12.1042857,8.00253968 C12.1042857,5.73438095 10.265619,3.89571429 7.99749206,3.89571429 L7.99749206,3.89571429 Z"
                id="Fill-4"
                fill="rgba(0,0,0,1)"
              ></path>
              <path
                d="M13.226254,3.73346032 C13.226254,4.26349206 12.7965714,4.69314286 12.2665397,4.69314286 C11.7365397,4.69314286 11.3068571,4.26349206 11.3068571,3.73346032 C11.3068571,3.20342857 11.7365397,2.77374603 12.2665397,2.77374603 C12.7965714,2.77374603 13.226254,3.20342857 13.226254,3.73346032"
                id="Fill-5"
                fill="rgba(0,0,0,1)"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)
